(() => {
  const setup = (section) => {
    if (section.dataset.orlisseRecentReady === 'true') return;

    const list = section.querySelector('[data-product-list]');
    if (!list) return;

    section.dataset.orlisseRecentReady = 'true';

    const update = () => {
      const count = list.children.length;
      const hasProducts = count > 0 && !section.classList.contains('hidden');

      section.classList.toggle('orlisse-recently-viewed--single', hasProducts && count === 1);
      document.body.classList.toggle('orlisse-recently-viewed-empty', !hasProducts);
    };

    new MutationObserver(update).observe(section, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });

    update();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-section-type="recently-viewed"]').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
